// reducers/pubsub/add.js

export function addHasErrored(state = false, action) {
  switch (action.type) {
    case 'ADD_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function addIsLoading(state = false, action) {
  switch (action.type) {
    case 'ADD_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function add(state = [], action) {
  switch (action.type) {
    case 'ADD_FETCH_DATA_SUCCESS':
      return action.response;
    default:
      return state;
  }
}